import { render } from "./SelectSelectorWidget.vue?vue&type=template&id=d0a19508"
import script from "./SelectSelectorWidget.vue?vue&type=script&lang=js"
export * from "./SelectSelectorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__